<template>
    <div class="declaracao-wrapper">
        <div v-if="!visualizandoPDF && !uploading">
            <declaracao-vinculo-header :dados="dadosHeader" :cnpj-contratada="cnpjContratada" class="mb-4" />

            <div class="d-flex justify-content-between align-items-end mb-2">
                <div class="w-50">
                    <b-input-group>
                        <b-form-input
                            id="input-busca"
                            v-model="filtro"
                            placeholder="Digite o nome, CPF ou cargo..."
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary" disabled>
                                <i class="fa fa-search"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div>
                    <b-button class="btn-custom-azul" :disabled="!editavel" @click="abrirModalAdicionar">
                        <i class="fa fa-plus mr-1"></i> Adicionar Profissional
                    </b-button>
                </div>
            </div>

            <div class="grid-section">
                <declaracao-vinculo-grid
                    :itens="itensFiltrados"
                    :editavel="editavel"
                    @editar="abrirModalEditar"
                    @excluir="abrirModalExclusao"
                />
            </div>

            <div class="mt-3 mb-3 d-flex justify-content-start align-items-center">
                <b-button variant="warning" class="mr-2" @click="voltarParaListaBoletins">
                    <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Voltar
                </b-button>

                <b-button v-if="podeGerarPdfParaAssinatura" class="btn-custom-azul" @click="handleVisualizarPDF">
                    <i class="fa fa-print mr-2"></i>
                    {{ textoBotaoGerarPdfAssinatura }}
                </b-button>
            </div>
        </div>

        <declaracao-vinculo-visualizar-p-d-f
            v-else-if="visualizandoPDF"
            :dadosHeader="dadosHeader"
            :boletimMedicaoId="boletimMedicaoId"
            :cnpjContratada="cnpjContratada"
            :itens="itens"
            :editavel="editavel"
            @voltar="visualizandoPDF = false"
            @proximo="irParaUpload"
        />

        <div v-else-if="uploading">
            <upload-arquivo-assinado
                ref="uploadAssinado"
                :contrato-id="contratoId"
                :disable-enviar="loadingUpload"
                :nome-arquivo-existente="nomeArquivoExistente"
                @file-selected="arquivoSelecionado = $event"
                @enviar-repositorio="enviarArquivoAssinado"
            />

            <div class="mt-3 mb-3 d-flex justify-content-start align-items-center">
                <b-button variant="warning" class="mr-2" @click="voltarParaPDF">
                    <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Voltar
                </b-button>
            </div>
        </div>

        <declaracao-vinculo-modal
            ref="modalAdicionar"
            :contratoId="contratoId"
            :itens="itens"
            @salvar="$emit('salvar', $event)"
            @atualizar="$emit('atualizar', $event)"
        />

        <declaracao-vinculo-exclusao-modal
            ref="modalExclusao"
            @confirmar="$emit('excluir', $event)"
        />
    </div>
</template>

<script>
import DeclaracaoVinculoHeader from './DeclaracaoVinculoHeader.vue';
import DeclaracaoVinculoGrid from './DeclaracaoVinculoGrid.vue';
import DeclaracaoVinculoVisualizarPDF from './DeclaracaoVinculoVisualizarPDF.vue';
import DeclaracaoVinculoModal from './DeclaracaoVinculoModal.vue';
import DeclaracaoVinculoExclusaoModal from './DeclaracaoVinculoExclusaoModal.vue';
import UploadArquivoAssinado from '../cronograma-planejamento/UploadArquivoAssinado.vue';
import BoletimMedicaoServicos from '../../../BoletimMedicaoServicos.js';
import { statusBoletimMedicaoEnum } from '../../../BoletimMedicao';
import { tiposAnexoEnum } from '../../../tiposAnexo.js';

export default {
    name: 'DeclaracaoVinculoTab',
    components: {
        DeclaracaoVinculoHeader,
        DeclaracaoVinculoGrid,
        DeclaracaoVinculoVisualizarPDF,
        DeclaracaoVinculoModal,
        DeclaracaoVinculoExclusaoModal,
        UploadArquivoAssinado
    },
    props: {
        dadosHeader: {
            type: Object,
            required: true,
            default: () => ({})
        },
        boletimMedicaoId: {
            type: [String, Number],
            required: true
        },
        contratoId: {
            type: String,
            required: true
        },
        // Recebe a lista de funcionários
        itens: {
            type: Array,
            default: () => []
        },
        cnpjContratada: {
            type: String,
            default: ''
        },
        editavel: {
            type: Boolean,
            default: true
        },
        statusBoletimMedicao: {
            type: Number,
            default: null
        },
        boletimMedicao: {
            type: Object,
            default: null
        },
        nomeArquivoExistente: {
            type: String,
            default: null
        },
        contrato: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            filtro: '',
            visualizandoPDF: false,
            uploading: false,
            arquivoSelecionado: null,
            loadingUpload: false
        }
    },
    computed: {
        cnpjFormatado() {
            return this.cnpjContratada || 'CNPJ NÃO INFORMADO';
        },
        itensFiltrados() {
            if (!this.filtro) return this.itens;
            const termo = this.filtro.toLowerCase();
            return this.itens.filter(item => {
                return (item.nomeCompleto && item.nomeCompleto.toLowerCase().includes(termo)) ||
                       (item.cpf && item.cpf.includes(termo)) ||
                       (item.cargo && item.cargo.toLowerCase().includes(termo));
            });
        },
        podeGerarPdfParaAssinatura() {
            return (this.$store.getters.isFornecedor
                && this.statusBoletimMedicao === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor)
                || (this.$store.getters.isFornecedor
                    && this.statusBoletimMedicao === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor
                    && this.boletimMedicao?.declaracaoVinculoEditavel)
                || (this.$temAcessoView('FISCAL-TERCEIRO')
                    && this.statusBoletimMedicao === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro);
        },
        textoBotaoGerarPdfAssinatura() {
            return 'Gerar PDF para Assinatura';
        },
        tipoAnexoDeclaracaoVinculoAssinadaAtual() {
            if (this.$store.getters.isFornecedor && this.statusBoletimMedicao === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor) {
                return tiposAnexoEnum.DeclaracaoVinculoAssinadaPeloFornecedor;
            }
            const tipoPorStatus = {
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor]: tiposAnexoEnum.DeclaracaoVinculoAssinadaPeloFornecedor,
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro]: tiposAnexoEnum.DeclaracaoVinculoAssinadaPeloFiscalTerceiro,
            };

            return tipoPorStatus[this.statusBoletimMedicao] || null;
        },
        documentoDeclaracaoVinculoAssinada() {
            const tipo = this.tipoAnexoDeclaracaoVinculoAssinadaAtual;
            if (!tipo) return null;
            return (this.boletimMedicao?.anexos || []).find(anexo => anexo.tipoAnexoBoletimMedicao === tipo) || null;
        }
    },
    methods: {
        abrirModalAdicionar() {
            if (this.$refs.modalAdicionar) {
                this.$refs.modalAdicionar.show();
            }
        },
        abrirModalEditar(profissional) {
            if (this.$refs.modalAdicionar) {
                this.$refs.modalAdicionar.show(profissional);
            }
        },
        abrirModalExclusao(profissional) {
            if (this.$refs.modalExclusao) {
                this.$refs.modalExclusao.show(profissional);
            }
        },
        fecharModalAdicionar() {
            if (this.$refs.modalAdicionar) {
                this.$refs.modalAdicionar.hide();
            }
        },
        handleVisualizarPDF() {
            if (!this.podeGerarPdfParaAssinatura) {
                return;
            }

            if (this.nomeArquivoExistente) {
                this.uploading = true;
                this.visualizandoPDF = false;
                return;
            }

            this.visualizandoPDF = true;
            this.uploading = false;
        },
        voltarParaListaBoletins() {
            this.$router.go(-1);
        },
        irParaUpload() {
            this.visualizandoPDF = false;
            this.uploading = true;
            this.arquivoSelecionado = null;
        },
        voltarParaPDF() {
            this.uploading = false;
            this.visualizandoPDF = true;
        },
        async enviarArquivoAssinado() {
            if (!this.arquivoSelecionado) {
                this.$toast.warning('Selecione um arquivo para enviar.');
                return;
            }

            this.loadingUpload = true;
            this.$store.dispatch('addRequest');

            try {
                const dto = {
                    tipo: this.tipoAnexoDeclaracaoVinculoAssinadaAtual,
                    arquivo: this.arquivoSelecionado
                };

                const documentoBoletimMedicaoId = this.documentoDeclaracaoVinculoAssinada?.documentoBoletimMedicaoId;
                const response = documentoBoletimMedicaoId
                    ? await BoletimMedicaoServicos.atualizarDocumentoBoletimMedicao(this.contratoId, this.boletimMedicaoId, documentoBoletimMedicaoId, dto)
                    : await BoletimMedicaoServicos.adicionarDocumentoBoletimMedicao(this.contratoId, this.boletimMedicaoId, dto);
                if (!response || !response.success) {
                    const mensagemErro = response?.errors?.join?.('; ') || 'Não foi possível enviar o arquivo.';
                    throw new Error(mensagemErro);
                }

                this.$toast.success('Arquivo enviado com sucesso!');
                this.uploading = true;
                this.visualizandoPDF = false;
                this.arquivoSelecionado = null;
                if (this.$refs.uploadAssinado) {
                    this.$refs.uploadAssinado.limparArquivoSelecionado()
                }
                this.$emit('recarregarDadosBoletim');
            } catch (error) {
                this.$toast.error('Erro ao enviar o arquivo.', 'Erro');
            } finally {
                this.$store.dispatch('removeRequest');
                this.loadingUpload = false;
            }
        }
    },
    mounted() {
        if (this.podeGerarPdfParaAssinatura && this.nomeArquivoExistente) {
            this.uploading = true;
            this.visualizandoPDF = false;
        }
    }
}
</script>

<style scoped>
.declaracao-wrapper {
    background-color: #fff;
    padding: 15px;
    border: 1px solid #ddd;
}

.texto-legal {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.9rem;
    text-align: justify;
    line-height: 1.5;
    color: #000;
    padding: 0 10px;
}

.btn-voltar-custom {
    background-color: #2F5597 !important;
    border-color: #2F5597 !important;
    color: #fff !important;
}
.btn-voltar-custom:hover {
    filter: brightness(0.9);
}

.btn-green-custom {
    background-color: #23A26D !important;
    border-color: #23A26D !important;
    color: #fff !important;
}
.btn-green-custom:hover {
    filter: brightness(0.9);
}
.btn-green-custom:disabled {
    background-color: #23A26D;
    border-color: #23A26D;
    opacity: 0.65;
}
</style>

<style>
.btn-custom-azul {
    background-color: #2E60AD !important;
    border-color: #2E60AD !important;
    color: #fff !important;
}

.btn-custom-azul:hover {
    filter: brightness(0.9);
    color: #fff !important;
}
</style>
